<template>
  <div class="basic_information">
    <div class="title">公司基本信息</div>
    <el-form style="width: 400px;" :model="info_form" :rules="rules" label-position="top" ref="infoForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="公司Logo" prop="logo">
        <UploadFileWidget ref="uploadFileRef" :accept="fileTypes.join(',')" :limit-size="1024 * 1024 * 200" :beforeUpload="handleBeforeUpload" @success="handleUploadSuccess" @error="isUpload = false">
          <div class="file-top_btn" slot="target">
            <img v-if="!info_form.logo" class="img_icon" src="../../assets/img/company/upload_icon.png" alt="">
            <span v-if="!info_form.logo"> 上传文件 </span>
            <img class="logo_img" v-else :src="info_form.logo" alt="">
          </div>
        </UploadFileWidget>
      </el-form-item>
      <el-form-item label="品牌名称" prop="brand_name">
        <el-input v-model="info_form.brand_name" placeholder="请输入品牌名称" :maxlength="10" show-word-limit> </el-input>
      </el-form-item>
      <el-form-item label="公司名称" prop="name">
        <el-input v-model="info_form.name" placeholder="请输入公司名称" :maxlength="30" show-word-limit> </el-input>
      </el-form-item>
      <el-form-item label="所在行业" prop="industry">
        <div class="show_industry" :style="{color:info_form.industry?'#606266':''}" @click="dialogVisible=true">{{ info_form.industry?info_form.industry:'请选择所在行业' }}</div>
        <!-- <el-input v-model="info_form.show_industry" placeholder="请选择所在行业"> </el-input> -->
      </el-form-item>
      <el-form-item label="融资阶段" prop="funding_stage">
        <el-select style="width: 100%;" v-model="info_form.funding_stage" placeholder="请选择">
          <el-option v-for="item in fundOption" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="人员规模" prop="staff_size">
        <el-select style="width: 100%;" v-model="info_form.staff_size" placeholder="请选择">
          <el-option v-for="item in staffOption" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-button class="save_button" @click="submitForm('infoForm')">保存</el-button>
    <SelectIndustryDialog v-model="dialogVisible" :type="info_form.industry" @confirm="confirmValue" @cancle="dialogVisible=false" />
  </div>
</template>

<script>
import { industryOption } from "../../utils/defaultData";
import SelectIndustryDialog from "./SelectIndustryDialog.vue";
import { formatFileSize, getFileIcon, getFileUnit } from "@/utils/common";
import UploadFileWidget from "@/utils/upload/UploadFileWidget.vue";
export default {
  name: "",
  data() {
    return {
      info_form: {
        logo: "", //企业Logo
        brand_name: "", //品牌名称
        name: "", //公司全称
        industry: "", //所在行业
        funding_stage: "", //融资阶段
        staff_size: "", //人员规模
      },
      rules: {
        logo: [
          { required: true, message: "请上传logo图片", trigger: "change" },
        ],
        brand_name: [
          { required: true, message: "请输入品牌名称", trigger: "blur" },
          {
            min: 1,
            max: 10,
            message: "长度在 1 到 10 个字符",
            trigger: "blur",
          },
        ],
        name: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
          {
            min: 2,
            max: 30,
            message: "长度在 2 到 30 个字符",
            trigger: "blur",
          },
        ],
        industry: [
          { required: true, message: "请选择所在行业", trigger: "change" },
        ],
        funding_stage: [
          { required: true, message: "请选择融资阶段", trigger: "change" },
        ],
        staff_size: [
          { required: true, message: "请选择人员规模", trigger: "change" },
        ],
      },
      fundOption: [
        {
          label: "未融资",
          value: "未融资",
        },
        {
          label: "天使轮",
          value: "天使轮",
        },
        {
          label: "A轮",
          value: "A轮",
        },
        {
          label: "B轮",
          value: "B轮",
        },
        {
          label: "C轮",
          value: "C轮",
        },
        {
          label: "D轮及以上",
          value: "D轮及以上",
        },
        {
          label: "已上市",
          value: "已上市",
        },
        {
          label: "不需要融资",
          value: "不需要融资",
        },
      ],
      staffOption: [
        {
          label: "0-20人",
          value: "0-20人",
        },
        {
          label: "20-99人",
          value: "20-99人",
        },
        {
          label: "100-499人",
          value: "100-499人",
        },
        {
          label: "500-999人",
          value: "500-999人",
        },
        {
          label: "1000-9999人",
          value: "1000-9999人",
        },
        {
          label: "10000人以上",
          value: "10000人以上",
        },
      ],
      industryOption: industryOption,
      dialogVisible: false,
      fileTypes: [".jpg", ".png", ".jpeg"],
      number: 0,
      isUpload: false,
    };
  },
  components: {
    SelectIndustryDialog,
    UploadFileWidget,
  },
  mounted() {
    this.getCompanyDetial()
  },

  watch: {
    info_form: {
      handler(newVal) {
        let keys = [
          "logo",
          "brand_name",
          "name",
          "industry",
          "funding_stage",
          "staff_size",
        ];
        let num = 0;
        for (let i = 0; i < keys.length; i++) {
          if (this.info_form[keys[i]]) {
            num += 1;
          }
        }
        this.$emit("changeNumber", num);
      },
      deep: true,
      immediate: false,
    },
  },
  methods: {
    confirmValue(val) {
      this.info_form.industry = val;
      this.dialogVisible = false;
    },
    handleBeforeUpload(file) {
      if (this.isUpload) {
        this.$message.warning("文件正在上传");
        return false;
      }

      this.isUpload = true;
      return true;
    },

    // 上传进度条
    handleUploadSuccess(val) {
      this.isUpload = false;
      this.info_form.logo = val.path;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$httpcompany.axiosPost(
            this.$api.companySaveBasicInfo,
            this.info_form,
            (res) => {
              if (res.code == 200) {
                this.$message.success("保存成功");
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            }
          );
          //
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getCompanyDetial() {
      this.$httpcompany.axiosGet(this.$api.companyDetail, (res) => {
        if (res.code == 200) {
          for (const key in this.info_form) {
            if (key in res.data && res.data[key]) {
              this.info_form[key] = res.data[key];
            }
          }
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.basic_information {
  padding-bottom: 20px;
  .title {
    font-weight: 500;
    font-size: 20px;
    color: #393837;
    margin-bottom: 34px;
  }
}
.show_industry {
  width: 400px;
  height: 40px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #dcdfe6;
  padding: 0 15px;
  box-sizing: border-box;
  font-weight: 400;
  font-size: 14px;
  color: #c4c7d9;
  cursor: pointer;
}
.file-top_btn {
  display: flex;
  width: 120px;
  height: 120px;
  background: #f6f6f6;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #e6e8eb;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 14px;
  color: #667085;
  cursor: pointer;
  .img_icon {
    width: 32px;
    height: 32px;
  }
  .logo_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
  }
}
.save_button {
  width: 86px;
  height: 34px;
  background: #685ef5;
  border-radius: 4px 4px 4px 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
}
</style>